import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiServices } from "../4.Utils/apiServices";

const namespace = "EmployeeCatagories";

export const getCatagories = createAsyncThunk(
  `${namespace}/employeeCatagories`,
  async (body, { rejectWithValue }) => {
    const api = "employeeCatagoriesList";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addCatagories = createAsyncThunk(
  `${namespace}/employeeCatagoriesAdd`,
  async (body, { rejectWithValue }) => {
    const api = "employeeCatagoryAdd";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  category: {
    id: "",
    description: "",
    short_description: "",
  },
  employeeCatagories: [],
  loading: false,
  error: false,
};

const EmployeeCatagoriesSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    updateCategory(state, action) {
      return { ...state, category: action.payload };
    },

    resetList(state) {
      return {
        ...state, 
        category: initialState.category,
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCatagories.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCatagories.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeCatagories = action.payload;
        console.log(action.payload);
      })
      .addCase(getCatagories.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        console.error(action.payload);
      })

      .addCase(addCatagories.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addCatagories.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addCatagories.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })
  },
});

export const { resetList, updateCategory } = EmployeeCatagoriesSlice.actions;
export default EmployeeCatagoriesSlice.reducer;